<div class="container" style="height: calc(100vh - 70px)">
  <img
    src="assets/images/wavezio_logo.png"
    loading="lazy"
    width="180px"
    class="img-fluid"
    alt="Wavezio."
  />
</div>
